
<main class="main">
  <router-outlet />
</main>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
